var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c1.336 0 2.567.724 3.216 1.892a.208.208 0 00.241.1 3.677 3.677 0 014.549 4.55.21.21 0 00.1.241A3.632 3.632 0 0120 10a3.63 3.63 0 01-1.894 3.217.21.21 0 00-.1.241 3.68 3.68 0 01-4.549 4.55.206.206 0 00-.24.1 3.68 3.68 0 01-6.434 0 .206.206 0 00-.24-.1 3.68 3.68 0 01-4.55-4.55.207.207 0 00-.1-.241 3.681 3.681 0 010-6.434.206.206 0 00.1-.24 3.681 3.681 0 014.549-4.551.207.207 0 00.241-.1A3.68 3.68 0 0110 0zm4.074 12.114a1.5 1.5 0 10-1.148 2.774 1.5 1.5 0 001.148-2.774zm.277-7.09a.853.853 0 00-.843.267L5.21 13.589a.852.852 0 001.2 1.201l8.299-8.298a.853.853 0 00-.358-1.468zM6.5 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: "#898B91",
    fillRule: "evenodd"
  })));
}
export default SvgPromoCode;